<template>
  <div id="warehouse-today-settings-container">
    <el-form
      :model="editForm"
      :rules="editFormRules"
      ref="editForm"
      size="mini"
      class="search-section-form"
    >
      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.receivingDate') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <span class="span-small-list">{{ warehouse.detail.receivingDate | moment(dateDisplayFormat) }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
            :label="$t('warehouse.settings.receivingDate')"
            prop="receivingDate"
          >
            <el-date-picker
              class="el-dropdown-new drop-sp date-dob"
              v-model="editForm.receivingDate"
              format="MM/dd/yyyy"
              type="date"
              :picker-options="warehouse.datePickerOptions"
              :clearable="false"
              @change="handleSearchReceivingLayouts()"
              ref="receivingDatePicker"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.receivingLayout') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <span class="span-small-list">{{ receivingLayout }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
            :label="$t('warehouse.settings.receivingLayout')"
            prop="receivingLayoutId"
            ref="receivingLayoutId"
          >
            <el-select
              v-model="editForm.receivingLayoutId"
              :no-data-text="noLayoutForReceivingDateMessage"
              ref="receivingLayoutId"
            >
              <el-option
                v-for="item in receivingLayouts"
                :key="item.id"
                :label="layoutName(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.blockedCutoffs') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <el-tooltip class="item" effect="dark" :content="warehouse.detail.blockedCutoffNames" placement="bottom-start">
            <span class="span-small-list">{{ warehouse.detail.blockedCutoffNames }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
            :label="$t('warehouse.settings.blockedCutoffs')"
            prop="blockedCutoffIds"
            ref="blockedCutoffIds"
          >
            <shipper-cutoff-group
              ref="shipperCutoffGroupSelect"
              :value.sync="editForm.blockedCutoffIds"
              :include-option-all="false"
              :include-option-none="false"
              :multiple="true" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.outboundDate') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <span class="span-small-list">{{ warehouse.detail.outboundDate | moment(dateDisplayFormat) }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
            :label="$t('warehouse.settings.outboundDate')"
            prop="outboundDate"
          >
            <el-date-picker
              class="el-dropdown-new drop-sp date-dob"
              v-model="editForm.outboundDate"
              format="MM/dd/yyyy"
              type="date"
              :picker-options="warehouse.datePickerOptions"
              :clearable="false"
              @change="handleSearchOutboundLayouts()"
              ref="outboundDatePicker"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.outboundLayout') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <span class="span-small-list">{{ outboundLayout }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
            :label="$t('warehouse.settings.outboundLayout')"
            prop="outboundLayoutId"
            ref="outboundLayoutId"
          >
            <el-select
              v-model="editForm.outboundLayoutId"
              :no-data-text="noLayoutForOutboundDateMessage"
            >
              <el-option
                v-for="item in outboundLayouts"
                :key="item.id"
                :label="layoutName(item)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="3" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <label class="margin-bottom-small-list">{{ $t('warehouse.settings.loadingSpeed') }}</label>
        </el-col>
        <el-col :span="5" class="list-name" v-show="!warehouse.isEditingTodaySettings">
          <span class="span-small-list">{{ warehouse.detail.loadingSpeed }}</span>
        </el-col>
        <el-col :span="8" v-show="warehouse.isEditingTodaySettings">
          <el-form-item
              :label="$t('warehouse.settings.loadingSpeed')"
              prop="loadingSpeed"
              ref="loadingSpeed"
          >
            <el-input
                class="inline-input"
                v-model="editForm.loadingSpeed"
                v-numeric-validation
                @focus="$event.target.select()"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24" class="text-align-end" v-show="warehouse.isEditingTodaySettings">
          <div id="general-settings-form-actions" class="reverse-form-actions">
            <el-button
                type="primary"
                id="form-save-button"
                @click="submitForm()"
                size="mini"
            >{{ $t('common.save') }}</el-button>
            <el-button
                id="form-refresh-button"
                @click="cancelEditSettings()"
                size="mini"
            >{{ $t('common.cancel') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import layoutService from '@/api/layoutService';
import ShipperCutoffGroup from '@/views/warehouse/shippers/components/ShipperCutoffGroup';
import warehouseBlockedCutoffGroupService from '@/api/warehouseBlockedCutoffGroupService';

export default {
  name: 'TodaySettings',
  components: { ShipperCutoffGroup },
  computed: {
    ...mapGetters(['user', 'warehouse']),
    dateDisplayFormat() {
      return constants.DATES.DEFAULT_DISPLAY_FORMAT;
    },
    minLoadingSpeed() {
      return constants.WAREHOUSE_SCHEDULE_SETTINGS.MIN_LOADING_SPEED;
    },
    maxLoadingSpeed() {
      return constants.WAREHOUSE_SCHEDULE_SETTINGS.MAX_LOADING_SPEED;
    },
    receivingLayout() {
      if (this.warehouse.detail.receivingLayoutId) {
        const dayName = constants.DAYS_OPTIONS.find(option => option.value === this.warehouse.detail.receivingLayoutDay.toString()).label;
        return dayName.concat(' - ').concat(this.warehouse.detail.receivingLayoutCode).concat(' - ').concat(this.warehouse.detail.receivingLayoutName);
      }
      return null;
    },
    outboundLayout() {
      if (this.warehouse.detail.outboundLayoutId) {
        const dayName = constants.DAYS_OPTIONS.find(option => option.value === this.warehouse.detail.outboundLayoutDay.toString()).label;
        return dayName.concat(' - ').concat(this.warehouse.detail.outboundLayoutCode).concat(' - ').concat(this.warehouse.detail.outboundLayoutName);
      }
      return null;
    },
    noLayoutForReceivingDateMessage() {
      return this.$t('warehouse.startDay.noLayoutForDate').replace('[date]', moment(this.editForm.receivingDate).format(this.dateDisplayFormat));
    },
    noLayoutForOutboundDateMessage() {
      return this.$t('warehouse.startDay.noLayoutForDate').replace('[date]', moment(this.editForm.outboundDate).format(this.dateDisplayFormat));
    }
  },
  data() {
    const validateLoadingSpeed = (rule, value, callback) => {
      if (!Number.isInteger(Number(value)) || Number(value) < this.minLoadingSpeed || Number(value) > this.maxLoadingSpeed) {
        callback(new Error(this.$t('warehouse.settings.error.loadingSpeedValid').replace('[minValue]', this.minLoadingSpeed).replace('[maxValue]', this.maxLoadingSpeed)));
      } else {
        callback();
      }
    };
    return {
      receivingLayouts: [],
      outboundLayouts: [],
      editForm: {
        warehouseId: null,
        receivingDate: null,
        receivingLayoutId: null,
        loadingSpeed: null,
        outboundDate: null,
        outboundLayoutId: null,
        blockedCutoffIds: [],
      },
      editFormRules: {
        receivingDate: [
          {
            required: true,
            message: this.$t('warehouse.startDay.error.dateRequired'),
            trigger: 'blur'
          }
        ],
        receivingLayoutId: [
          {
            required: true,
            message: this.$t('warehouse.startDay.error.layoutRequired'),
            trigger: 'blur'
          }
        ],
        loadingSpeed: [
          { validator: validateLoadingSpeed, trigger: 'blur' },
          {
            required: true,
            message: this.$t('warehouse.startDay.error.loadingSpeedRequired'),
            trigger: 'blur'
          }
        ],
        outboundDate: [
          {
            required: true,
            message: this.$t('warehouse.startDay.error.dateRequired'),
            trigger: 'blur'
          }
        ],
        outboundLayoutId: [
          {
            required: true,
            message: this.$t('warehouse.startDay.error.layoutRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    async handleSearchReceivingLayouts() {
      this.$refs.receivingLayoutId.resetField();
      this.editForm.receivingLayoutId = null;
      this.receivingLayouts = await this.handleSearchLayouts(this.editForm.warehouseId, this.editForm.receivingDate, this.editForm.receivingDate);
      this.editForm.blockedCutoffIds = await this.handleSearchBlockedCutoff(this.editForm.warehouseId, this.editForm.receivingDate);
    },
    async handleSearchOutboundLayouts() {
      this.$refs.outboundLayoutId.resetField();
      this.editForm.outboundLayoutId = null;
      this.$refs.loadingSpeed.resetField();
      const day = moment(this.editForm.outboundDate.getTime()).day();
      const daySchedule = this.warehouse.detail.warehouseSchedule.find(schedule => schedule.dayNumber === day);
      if (daySchedule) {
        this.editForm.loadingSpeed = daySchedule.loadingSpeed;
      }
      this.outboundLayouts = await this.handleSearchLayouts(this.editForm.warehouseId, this.editForm.outboundDate, this.editForm.outboundDate);
    },
    async handleSearchLayouts(warehouseId, layoutDateFrom, layoutDateTo) {
      const response = await layoutService.search({ warehouseId, layoutDateFrom, layoutDateTo });
      if (response && response.data) {
        return response.data;
      }
      return [];
    },
    async handleSearchBlockedCutoff(warehouseId, receivingDate) {
      const response = await warehouseBlockedCutoffGroupService.getWarehouseBlockedCutoffGroup({ warehouseId, receivingDate });
      if (response && response.data) {
        return response.data.map(blockedGroup => blockedGroup.shipperCutoffGroupId);
      }
      return [];
    },
    layoutName(layout) {
      return moment(layout.layoutDate).format(constants.DATES.DEFAULT_DISPLAY_FORMAT)
        .concat(' ')
        .concat(layout.dayName)
        .concat(' - ')
        .concat(layout.code)
        .concat(' - ')
        .concat(layout.name);
    },
    submitForm() {
      const day = moment(this.editForm.outboundDate.getTime()).day();
      const daySchedule = this.warehouse.detail.warehouseSchedule.find(schedule => schedule.dayNumber === day);
      if (!daySchedule || !daySchedule.dataEntryCutOff) {
        const dayName = constants.DAYS_OPTIONS.find(option => option.value === day.toString()).label;
        this.$message.error(this.$t('warehouse.startDay.error.dataEntryCutOffNotConfigured').replace('[dayOfWeek]', dayName));
        return;
      }
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          try {
            const response = await this.$store.dispatch('warehouse/updateStartDay', { warehouseId: this.editForm.warehouseId, startDayData: this.editForm });
            this.$message.success(response.message);
            this.cancelEditSettings();
          } finally {
            loading.close();
          }
        }
      });
    },
    async resetForm() {
      this.$refs.editForm.resetFields();
      this.editForm.warehouseId = this.user.warehouseId;
      this.editForm.receivingDate = moment(this.warehouse.detail.receivingDate, constants.DATES.DEFAULT_BACKEND_FORMAT).toDate();
      this.editForm.loadingSpeed = this.warehouse.detail.loadingSpeed;
      this.editForm.outboundDate = moment(this.warehouse.detail.outboundDate, constants.DATES.DEFAULT_BACKEND_FORMAT).toDate();
      this.receivingLayouts = await this.handleSearchLayouts(this.editForm.warehouseId, this.editForm.receivingDate, this.editForm.receivingDate);
      this.editForm.receivingLayoutId = this.warehouse.detail.receivingLayoutId;
      this.outboundLayouts = await this.handleSearchLayouts(this.editForm.warehouseId, this.editForm.outboundDate, this.editForm.outboundDate);
      this.editForm.outboundLayoutId = this.warehouse.detail.outboundLayoutId;
      this.editForm.blockedCutoffIds = this.warehouse.detail.blockedCutoffIds;
      this.$nextTick(() => {
        this.$refs.shipperCutoffGroupSelect.setSelectedShipperCutoffGroup(this.editForm.blockedCutoffIds);
      });
    },
    cancelEditSettings() {
      this.$store.dispatch('warehouse/setEditingTodaySettings', false);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .reverse-form-actions {
    margin-bottom: 18px;
  }
</style>
